import React from "react";
import __pages_import_0__ from "/src/pages/index.tsx";
const __pages_import_1__ = React.lazy(() => import("/src/pages/support-requests/new.tsx"));

const routes = [{"caseSensitive":false,"path":"/","element":React.createElement(__pages_import_0__)},{"caseSensitive":false,"path":"support-requests","children":[{"caseSensitive":false,"path":"new","element":React.createElement(__pages_import_1__)}]}];

export default routes;